<template>
    <div class="exercise-tests-form">
      <div class="add-test-form" v-if="showTestForm">
        <ExerciseTestForm
          :test="localTest" 
          :onClose="closeTestForm"
          @finish-edit-test="saveTest"
        />
      </div>
      <div v-if="!showTestForm">
        <div class="mt-8 answer" v-for="test in getCurrentTests" :key="test.id">
          <exercise-test
            :exercise="exercise"
            :test="test"
            :onEdit="editTest"
            @delete-test="deleteTest"
          />
        </div>
      </div>
      <div v-if="!showTestForm" class="add-test-btn flex text-lg mt-10 cursor-pointer" @click.stop="addTest()"><feather-icon icon="PlusCircleIcon" svgClasses="h-6 w-6" class="mr-4" />
        Add Test
      </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { testFactory } from '@/store/exercise/factories.js'
import ExerciseTest from './ExerciseTest'
import ExerciseTestForm from './ExerciseTestForm'

export default {
  components: {
    ExerciseTest,
    ExerciseTestForm
  },
  props: {
    exercise: Object
  },
  data () {
    return {
      localTest: {},
      showTestForm: false
    }
  },
  computed: {
    ...mapGetters('exercises', ['getCurrentTests']),
  },
  methods: {
    ...mapActions('exercises', ['saveTestExerciseToApi', 'deleteATest']),
    async saveTest(test) {
      try {
        this.localTest = {...test}
        this.$vs.loading()
        await this.saveTestExerciseToApi({
          ...this.localTest
        })
        this.showTestForm = false
        this.$vs.notify({
          title: "Success",
          text: 'Test saved',
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success"
        })
      } catch (error) {
        this.showError(error)
      }
      this.$vs.loading.close()
    },
    async deleteTest(payload) {
      try {
        this.$vs.loading()
        await this.deleteATest({
          ...payload,
          deleteFunc: this.$delete
        })
        this.$vs.notify({
          title: "Success",
          text: 'Test deleted',
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success"
        })
      } catch (error) {
        this.showError(error)
      }
      this.$vs.loading.close()
    },
    addTest () {
      this.localTest = {...testFactory(this.exercise.id)}
      this.showTestForm = true
    },
    editTest(test) {
      this.localTest = {...test}
      this.showTestForm = true
    },
    closeTestForm () {
      this.showTestForm = false
    }
  },
}
</script>
<style lang="scss" scoped>
  .exercise-tests-form {
    min-height: 50vh;
  }
  code {
    padding: 0;
  }
</style>